// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio {
    padding-bottom: 1.25em;
}

    .radio > * {
        margin-right: 7px;
    }`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/reltoobject/reltoobject.settings.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;IAEI;QACI,iBAAiB;IACrB","sourcesContent":[".radio {\n    padding-bottom: 1.25em;\n}\n\n    .radio > * {\n        margin-right: 7px;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
